export default {"src":"/_next/static/image/public/images/flags/flag_233.19949537a068c7746ff3ba77fe45ec12.svg","height":16,"width":25};